(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => [...root.querySelectorAll(sel)];

  const moneyFormat = window.theme?.moneyFormat || '${{amount}}';

  function formatMoney(cents, format = moneyFormat) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = (Number(cents) || 0) / 100;
    const parts = value.toFixed(2).split('.');
    const amount = `${Number(parts[0]).toLocaleString('en-US')}.${parts[1]}`;
    const amountNoDecimals = Number(parts[0]).toLocaleString('en-US');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  /* ---------- Drawers ---------- */
  const openDrawer = (sel) => qs(sel)?.classList.add('is-open');
  const closeDrawer = (sel) => qs(sel)?.classList.remove('is-open');

  function bindDrawerTriggers() {
    qsa('[data-open-search]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer('[data-search-drawer]');
        qs('[data-search-drawer] input')?.focus();
      });
    });
    qsa('[data-close-search]').forEach((el) => el.addEventListener('click', () => closeDrawer('[data-search-drawer]')));
    qsa('[data-open-cart]').forEach((el) => {
      el.addEventListener('click', (e) => {
        if (!window.themeSettings?.cartDrawer) return;
        e.preventDefault();
        openDrawer('[data-cart-drawer]');
      });
    });
    qsa('[data-close-cart]').forEach((el) => el.addEventListener('click', () => closeDrawer('[data-cart-drawer]')));
  }
  bindDrawerTriggers();

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeDrawer('[data-search-drawer]');
      closeDrawer('[data-cart-drawer]');
      closeLightbox();
    }
  });

  /* ---------- Mobile nav ---------- */
  const menuToggle = qs('[data-menu-toggle]');
  const mobileNav = qs('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Announcement / Slideshow / Tabs ---------- */
  qsa('[data-announcement]').forEach((root) => {
    const track = qs('[data-announcement-slides]', root);
    const slides = qsa('[data-announcement-slide]', root);
    if (!track || slides.length < 2) return;
    let index = 0;
    const go = (i) => {
      index = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
    };
    qs('[data-announcement-prev]', root)?.addEventListener('click', () => go(index - 1));
    qs('[data-announcement-next]', root)?.addEventListener('click', () => go(index + 1));
    if (root.dataset.autoplay === 'true') {
      setInterval(() => go(index + 1), Number(root.dataset.autoplaySpeed || 5) * 1000);
    }
  });

  qsa('[data-slideshow]').forEach((root) => {
    const track = qs('[data-slideshow-track]', root);
    const slides = qsa('[data-slideshow-slide]', root);
    const dots = qsa('[data-slideshow-dot]', root);
    if (!track || slides.length < 2) return;
    let index = 0;
    const go = (i) => {
      index = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      dots.forEach((d, di) => d.classList.toggle('is-active', di === index));
    };
    dots.forEach((d, di) => d.addEventListener('click', () => go(di)));
    if (root.dataset.autoplay === 'true') {
      setInterval(() => go(index + 1), Number(root.dataset.autoplaySpeed || 6) * 1000);
    }
  });

  qsa('[data-featured-tabs]').forEach((root) => {
    const buttons = qsa('[data-tab-btn]', root);
    const panels = qsa('[data-tab-panel]', root);
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.tabBtn;
        buttons.forEach((b) => b.classList.toggle('is-active', b === btn));
        panels.forEach((p) => p.classList.toggle('is-active', p.dataset.tabPanel === id));
      });
    });
  });

  /* ---------- Cart API ---------- */
  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach((el) => {
      el.textContent = String(count || 0);
    });
  }

  function renderCartDrawer(cart) {
    const body = qs('[data-cart-drawer-body]');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = `<div class="empty-state">${window.theme?.strings?.cartEmpty || 'Your cart is empty'}</div>`;
      return;
    }
    const items = cart.items.map((item) => `
      <div class="cart-item" style="margin-bottom:1rem;" data-key="${item.key}">
        ${item.image ? `<img src="${item.image}&width=160" alt="" width="88" height="110" loading="lazy">` : ''}
        <div>
          <a href="${item.url}"><strong>${item.product_title}</strong></a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="color:#777;font-size:0.85rem;">${item.variant_title}</div>` : ''}
                       <div>${(() => { const r = cart.items_subtotal_price ? cart.total_price / cart.items_subtotal_price : 1; const fp = Math.round(item.final_price * r); const tags = [...(item.line_level_discount_allocations || []).map((d) => d.discount_application.title), ...(r < 1 ? (cart.cart_level_discount_applications || []).map((d) => d.title) : [])]; const icon = '<svg width="9" height="9" viewBox="0 0 24 24" fill="#fff" style="vertical-align:-1px;margin-right:3px;"><path d="M21.4 11.6l-9-9A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7c0 .55.22 1.05.59 1.42l9 9a2 2 0 0 0 2.82 0l7-7a2 2 0 0 0 0-2.82zM6.5 8A1.5 1.5 0 1 1 8 6.5 1.5 1.5 0 0 1 6.5 8z"/></svg>'; const tag = (t) => `<div style="display:block;width:fit-content;margin-top:4px;padding:2px 6px;background:#000;color:#fff;font-size:0.65rem;font-weight:700;line-height:1.3;text-transform:uppercase;letter-spacing:0.2px;border-radius:2px;">${icon}${t}</div>`; return (fp < item.original_price ? `<span style="color:#c8102e;">${formatMoney(fp)}</span> <s style="color:#999;font-size:0.85em;">${formatMoney(item.original_price)}</s>` : formatMoney(item.final_price)) + tags.map(tag).join(''); })()}</div>
            <a href="/cart/change?id=${item.key}&quantity=0">Remove</a>
          <div class="cart-drawer-qty">
            <button type="button" data-cart-qty-change data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-qty-change data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
          </div>
        </div>
      </div>
    `).join('');
    body.innerHTML = `
      ${items}
      <div style="margin-top:1rem;">
        <div style="display:flex;justify-content:space-between;margin-bottom:0.75rem;">
          <span>${window.theme?.strings?.subtotal || 'Subtotal'}</span>
          <strong>${formatMoney(cart.total_price)}</strong>
        </div>
        <button type="button" class="btn cart-drawer__checkout-button" id="ntcCartDrawerCheckoutBtn" onclick="if(window.ntcCartDrawerCheckoutBtn){window.ntcCartDrawerCheckoutBtn(event);}else{window.location='/cart';}" style="width:100%;">${window.theme?.strings?.checkout || 'Checkout'}</button>
        <button type="button" class="cart-drawer__continue-shopping" onclick="document.querySelector('[data-cart-drawer]')?.classList.remove('is-open')">CONTINUE SHOPPING</button>
      </div>
    `;
    body.querySelectorAll('[data-cart-qty-change]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        await changeCartQty(btn.dataset.key, Number(btn.dataset.qty));
      });
    });
  }

  async function refreshCartUI(open = false) {
    const cart = await fetchCart();
    updateCartCount(cart.item_count);
    renderCartDrawer(cart);
   if (open) openDrawer('[data-cart-drawer]');
    return cart;
  }
  window.refreshCartUI = refreshCartUI;

  async function changeCartQty(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity }),
    });
    await refreshCartUI(true);
  }

  async function addToCart(payload) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
    await refreshCartUI(true);
    return data;
  }

  /* ---------- Product gallery + lightbox ---------- */
  let lightboxIndex = 0;
  let lightboxSources = [];

  function closeLightbox() {
    const lb = qs('[data-gallery-lightbox]');
    if (!lb) return;
    lb.hidden = true;
    document.body.style.overflow = '';
  }

  function openLightbox(index) {
    const lb = qs('[data-gallery-lightbox]');
    const img = qs('[data-lightbox-image]');
    if (!lb || !img || !lightboxSources.length) return;
    lightboxIndex = (index + lightboxSources.length) % lightboxSources.length;
    img.src = lightboxSources[lightboxIndex].zoom || lightboxSources[lightboxIndex].src;
    img.alt = lightboxSources[lightboxIndex].alt || '';
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function initGallery(root) {
    const main = qs('[data-gallery-main]', root);
    const thumbs = qsa('[data-gallery-thumb]', root);
    if (!main || !thumbs.length) return;

    lightboxSources = thumbs.map((t) => ({
      src: t.dataset.src,
      zoom: t.dataset.zoom || t.dataset.src,
      alt: t.querySelector('img')?.alt || '',
    }));

    let index = 0;
    const go = (i) => {
      index = (i + thumbs.length) % thumbs.length;
      const thumb = thumbs[index];
      main.src = thumb.dataset.src;
      thumbs.forEach((b, bi) => b.classList.toggle('is-active', bi === index));
    };

    thumbs.forEach((btn, i) => btn.addEventListener('click', () => go(i)));
    qs('[data-gallery-prev]', root)?.addEventListener('click', () => go(index - 1));
    qs('[data-gallery-next]', root)?.addEventListener('click', () => go(index + 1));
    qs('[data-gallery-zoom-open]', root)?.addEventListener('click', (e) => {
      if (e.target.closest('[data-gallery-prev], [data-gallery-next]')) return;
      openLightbox(index);
    });
  }

  qsa('[data-product-gallery]').forEach(initGallery);
  qs('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
  qs('[data-lightbox-prev]')?.addEventListener('click', () => openLightbox(lightboxIndex - 1));
  qs('[data-lightbox-next]')?.addEventListener('click', () => openLightbox(lightboxIndex + 1));
  qs('[data-gallery-lightbox]')?.addEventListener('click', (e) => {
    if (e.target.hasAttribute('data-gallery-lightbox')) closeLightbox();
  });

  /* ---------- Product form / variants ---------- */
  function initProductForm(section) {
    const form = qs('[data-product-form]', section);
    const jsonEl = qs('[data-product-json]', section);
    const idInput = qs('[data-product-variant-id]', section);
    if (!form || !jsonEl || !idInput) return;

    const product = JSON.parse(jsonEl.textContent);
    const variants = product.variants || [];
    const optionInputs = qsa('[data-option-value]', form);
    const priceEl = qs('[data-product-price]', section);
    const compareEl = qs('[data-product-compare]', section);
    const saveEl = qs('[data-product-save]', section);
    const skuEl = qs('[data-product-sku]', section);
    const submitBtn = qs('[data-add-to-cart]', form);
    const submitText = qs('[data-add-to-cart-text]', form);
    const errorEl = qs('[data-product-error]', form);
    const sticky = qs('[data-sticky-atc]');
    const stickyPrice = qs('[data-sticky-price]');
    const stickyBtn = qs('[data-sticky-atc-btn]');
    const qtyInput = qs('[data-qty-input]', form);

    const getSelectedOptions = () => {
      const selected = [];
      for (let i = 1; i <= (product.options?.length || 0); i++) {
        const checked = form.querySelector(`input[name="option${i}"]:checked`);
        selected.push(checked ? checked.value : null);
      }
      return selected;
    };

    const findVariant = (options) =>
      variants.find((v) => options.every((val, idx) => !val || v[`option${idx + 1}`] === val));

    const optionIsAvailable = (position, value, current) => {
      const trial = current.slice();
      trial[position - 1] = value;
      return variants.some((v) => {
        const matches = trial.every((val, idx) => !val || v[`option${idx + 1}`] === val);
        return matches && v.available;
      });
    };

    const sync = () => {
      const selected = getSelectedOptions();
      selected.forEach((val, idx) => {
        const label = qs(`[data-option-index="${idx}"] [data-option-selected]`, section);
        if (label && val) label.textContent = val;
      });

      optionInputs.forEach((input) => {
        const pos = Number(input.dataset.optionPosition);
        const available = optionIsAvailable(pos, input.value, selected);
        input.disabled = false;
        const lab = form.querySelector(`label[for="${input.id}"]`);
        lab?.classList.toggle('is-unavailable', !available);
      });

      const match = findVariant(selected);
      if (!match) {
        if (submitBtn) {
          submitBtn.disabled = true;
          if (submitText) submitText.textContent = window.theme?.strings?.unavailable || 'Unavailable';
        }
        return;
      }

      idInput.value = match.id;
      if (priceEl) {
        priceEl.textContent = formatMoney(match.price);
        priceEl.classList.toggle('sale', match.compare_at_price > match.price);
      }
      if (compareEl) {
        if (match.compare_at_price > match.price) {
          compareEl.hidden = false;
          compareEl.textContent = formatMoney(match.compare_at_price);
        } else {
          compareEl.hidden = true;
        }
      }
      if (saveEl) {
        if (match.compare_at_price > match.price) {
          const pct = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
          saveEl.hidden = false;
          saveEl.textContent = `Save ${pct}%`;
        } else {
          saveEl.hidden = true;
        }
      }
      if (skuEl) skuEl.textContent = match.sku ? `SKU: ${match.sku}` : '';
      if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);

      if (submitBtn) {
        submitBtn.disabled = !match.available;
        if (submitText) {
          submitText.textContent = match.available
            ? (window.theme?.strings?.addToCart || 'Add to cart')
            : (window.theme?.strings?.soldOut || 'Sold out');
        }
      }
      if (stickyBtn) {
        stickyBtn.disabled = !match.available;
        stickyBtn.textContent = match.available
          ? (window.theme?.strings?.addToCart || 'Add to cart')
          : (window.theme?.strings?.soldOut || 'Sold out');
      }

      // Switch gallery to variant image when possible
      if (match.featured_image) {
        const src = match.featured_image.src?.replace(/(\.[^.]+)(\?|$)/, '_1400x$1$2') || match.featured_image;
        const main = qs('[data-gallery-main]', section);
        if (main && typeof src === 'string') {
          // featured_image from variants JSON uses CDN url without size filter sometimes
          const url = match.featured_image.src
            ? match.featured_image.src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master)/, '')
            : null;
          if (url) main.src = url.includes('?') ? `${url}&width=1400` : `${url}?width=1400`;
        }
      }
    };

    optionInputs.forEach((el) => el.addEventListener('change', sync));
    sync();

    qs('[data-qty-minus]', form)?.addEventListener('click', () => {
      const v = Math.max(1, Number(qtyInput.value || 1) - 1);
      qtyInput.value = v;
    });
    qs('[data-qty-plus]', form)?.addEventListener('click', () => {
      qtyInput.value = Math.max(1, Number(qtyInput.value || 1) + 1);
    });

    const doAdd = async () => {
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      try {
        submitBtn && (submitBtn.disabled = true);
        await addToCart({
          id: Number(idInput.value),
          quantity: Number(qtyInput?.value || 1),
        });
      } catch (err) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = err.message;
        }
      } finally {
        sync();
      }
    };

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      doAdd();
    });
    stickyBtn?.addEventListener('click', () => doAdd());

    if (sticky && submitBtn) {
      const io = new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting;
      }, { threshold: 0 });
      io.observe(submitBtn);
    }
  }

  qsa('[data-product-section]').forEach(initProductForm);

  /* ---------- Related products (Recommendations API) ---------- */
  qsa('[data-related-products]').forEach(async (root) => {
    const url = root.dataset.url;
    const grid = qs('[data-related-grid]', root);
    if (!url || !grid) return;
    // If already has cards from fallback, still try recommendations for better match
    try {
      const res = await fetch(url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = doc.querySelector('[data-related-grid]');
      if (nextGrid && nextGrid.querySelector('.product-card')) {
        grid.innerHTML = nextGrid.innerHTML;
      }
    } catch (_) {
      /* keep fallback */
    }
  });

  /* ---------- Cart page quantity (optional ajax) ---------- */
  // Initial drawer hydrate when opening first time with server HTML is fine.

  /* ---------- Mobile submenu ---------- */
  qsa('[data-mobile-submenu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const sub = btn.closest('.mobile-nav__item')?.querySelector('.mobile-nav__sub');
      if (!sub) return;
      const open = sub.hasAttribute('hidden');
      if (open) sub.removeAttribute('hidden');
      else sub.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? '−' : '+';
    });
  });

  /* ---------- Size chart modal ---------- */
  const openSizeChart = () => {
    const m = qs('[data-size-chart-modal]');
    if (!m) return;
    m.hidden = false;
    document.body.style.overflow = 'hidden';
  };
  const closeSizeChart = () => {
    const m = qs('[data-size-chart-modal]');
    if (!m) return;
    m.hidden = true;
    document.body.style.overflow = '';
  };
  qsa('[data-open-size-chart]').forEach((el) => el.addEventListener('click', openSizeChart));
  qsa('[data-close-size-chart]').forEach((el) => el.addEventListener('click', closeSizeChart));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSizeChart();
  });

  /* ---------- Quick add on product cards ---------- */
  qsa('[data-quick-add]').forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const id = Number(btn.dataset.variantId);
      if (!id) return;
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';
      try {
        await addToCart({ id, quantity: 1 });
        btn.textContent = 'Added';
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 1200);
      } catch (err) {
        btn.textContent = 'Error';
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 1500);
      }
    });
  });
})();
